/**
 * com.remedirx.apps.MyRemedi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ActivePrescriberInfo } from './activePrescriberInfo';
import { NursingStation } from './nursingStation';


/**
 * MedSearchOptions
 */
export interface MedSearchOptions { 
    /**
     * RxType
     */
    RxType?: string;
    /**
     * OrderType
     */
    OrderType?: string;
    /**
     * OrderStatus
     */
    OrderStatus?: MedSearchOptions.OrderStatusEnum;
    /**
     * ResidentStatus
     */
    ResidentStatus?: MedSearchOptions.ResidentStatusEnum;
    /**
     * Prescribers
     */
    Prescribers?: Array<ActivePrescriberInfo>;
    /**
     * NursingStations
     */
    NursingStations?: Array<NursingStation>;
    /**
     * OriginalStartDate
     */
    OriginalStartDate?: Date;
    /**
     * OriginalEndDate
     */
    OriginalEndDate?: Date;
    /**
     * GpiValueList
     */
    GpiValueList?: Array<string>;
    /**
     * Used to identify what the highest possible field to show should be when searching
     */
    HighestGpiFieldType?: MedSearchOptions.HighestGpiFieldTypeEnum;
}
export namespace MedSearchOptions {
    export type OrderStatusEnum = 'None' | 'Inactive' | 'Active' | 'Both';
    export const OrderStatusEnum = {
        None: 'None' as OrderStatusEnum,
        Inactive: 'Inactive' as OrderStatusEnum,
        Active: 'Active' as OrderStatusEnum,
        Both: 'Both' as OrderStatusEnum
    };
    export type ResidentStatusEnum = 'None' | 'Inactive' | 'Active' | 'Both';
    export const ResidentStatusEnum = {
        None: 'None' as ResidentStatusEnum,
        Inactive: 'Inactive' as ResidentStatusEnum,
        Active: 'Active' as ResidentStatusEnum,
        Both: 'Both' as ResidentStatusEnum
    };
    export type HighestGpiFieldTypeEnum = 'Group' | 'Class' | 'SubClass' | 'Name';
    export const HighestGpiFieldTypeEnum = {
        Group: 'Group' as HighestGpiFieldTypeEnum,
        Class: 'Class' as HighestGpiFieldTypeEnum,
        SubClass: 'SubClass' as HighestGpiFieldTypeEnum,
        Name: 'Name' as HighestGpiFieldTypeEnum
    };
}
